export default {
  placeholders: {
    first_name: 'First name',
    last_name: 'Last name',
    email: 'Email',
    mobile_number: 'Mobile number',
  },
  labels: {
    exclusive_offers_via_email: 'I`d like to receive exclusive offers and news by email.',
  },
  buttons: {
    sign_up: 'Sign up',
  },
};
